// extracted by mini-css-extract-plugin
module.exports = {"AppFrame":"App_AppFrame__1BVTD","cssBoxes":"App_cssBoxes__2Cguh","Main":"App_Main__3Eoue","TitleBar":"App_TitleBar__2ixIJ"};